import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
export var MediaItemUser = function MediaItemUser(_ref) {
  var media_visibilities_id = _ref.media_visibilities_id,
      email = _ref.email;

  _classCallCheck(this, MediaItemUser);

  this.media_visibilities_id = media_visibilities_id;
  this.email = email;
};